import { render, staticRenderFns } from "./ProModal.vue?vue&type=template&id=288592ff&scoped=true"
import script from "./ProModal.vue?vue&type=script&lang=js"
export * from "./ProModal.vue?vue&type=script&lang=js"
import style0 from "./ProModal.vue?vue&type=style&index=0&id=288592ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288592ff",
  null
  
)

export default component.exports